"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _reactRedux = require("react-redux");
var _configuratorSecondaryNavigation = require("@mmc/configurator-secondary-navigation");
var _configuratorSmallSummary = require("@mmc/configurator-small-summary");
var _commonDialog = require("@mmc/common-dialog");
var _reactScrollTrigger = _interopRequireDefault(require("react-scroll-trigger"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonLibs = require("@mmc/common-libs");
var _commonSetLocation = require("@mmc/common-set-location");
var _actions = require("../actions");
var _preferencesSelector = _interopRequireDefault(require("./preferences-selector"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  isEmptyObject = dataUtils.isEmptyObject,
  isEmptyArray = dataUtils.isEmptyArray,
  appendImageTransforms = dataUtils.appendImageTransforms;
var carouselUpdateAttributes = ['color', 'fabric', 'model', 'trimLine', 'packages', 'accessories'];

// Transform our items in phases based on break steps indices
var getShapedSecondaryNavData = function getShapedSecondaryNavData(_ref) {
  var progressBar = _ref.progressBar,
    backEvent = _ref.backEvent,
    changeStepEvents = _ref.changeStepEvents,
    eventKeys = _ref.eventKeys,
    phaseBreaks = _ref.phaseBreaks,
    stepMap = _ref.stepMap;
  // Make a deep copy of the progressBar object
  var updatedProgressBar = JSON.parse(JSON.stringify(progressBar));

  // Initiate our object with phases
  var shapedProgressBarData = {
    phases: []
  };
  for (var i = 0; i <= phaseBreaks.length; i += 1) {
    // Initiate our phase with steps
    shapedProgressBarData.phases[i] = {
      steps: []
    };
    var currentPhase = shapedProgressBarData.phases[i];
    var startingStep = i === 0 ? 0 : phaseBreaks[i - 1] + 1;

    // Set our defaults
    currentPhase.previousCta = JSON.parse(JSON.stringify(updatedProgressBar.previousCta));
    currentPhase.previousCta.clickEvent = backEvent;
    currentPhase.nextSteps = updatedProgressBar.startConfigurationTitle;
    currentPhase.layout = 'grey_arrow';

    // Set specifics on last step
    if (i === phaseBreaks.length) {
      currentPhase.nextSteps = '';
      currentPhase.layout = 'white_arrow';
      currentPhase.id = 'model_menu';
      currentPhase.name = 'model_menu';
    }

    // Add steps to the phase until we need to break
    var _loop = function _loop(j) {
      var mappedIndex = stepMap.findIndex(function (step) {
        return step.stepName === updatedProgressBar.items[j].stepName;
      });
      updatedProgressBar.items[j].changeEvent = changeStepEvents[eventKeys[mappedIndex]];
      updatedProgressBar.items[j].eventId = eventKeys[mappedIndex];
      var currentStep = updatedProgressBar.items[j];
      currentPhase.steps.push(currentStep);

      // Stop adding steps once we"ve reached the current break step
      if (j === phaseBreaks[i]) {
        return 1; // break
      }
    };
    for (var j = startingStep; j < updatedProgressBar.items.length; j += 1) {
      if (_loop(j)) break;
    }
  }
  return shapedProgressBarData;
};
var getNextStepLabel = function getNextStepLabel(progressBar) {
  if (progressBar === void 0) {
    progressBar = {};
  }
  var items = progressBar.items || [];
  var nextStep = items.find(function (item, i) {
    if (items[i - 1] !== undefined) {
      return items[i - 1].selected;
    }
    return false;
  });
  return nextStep ? " " + nextStep.label : '';
};
var getFirstStepOfActivePhaseFromProgressBar = function getFirstStepOfActivePhaseFromProgressBar(progressBar, phaseBreaks) {
  if (progressBar === void 0) {
    progressBar = {};
  }
  var items = progressBar.items || [];
  var activeStepIndex = items.findIndex(function (item) {
    return item.selected;
  });
  var firstStepOfPhase = 0;
  for (var i = phaseBreaks.length - 1; i >= 0; i -= 1) {
    if (activeStepIndex > phaseBreaks[i]) {
      firstStepOfPhase = phaseBreaks[i];
      break;
    }
  }
  return firstStepOfPhase;
};
var setBodyScrollability = function setBodyScrollability(willScroll) {
  var maxWidth = 768;
  if (typeof window !== 'undefined') {
    var width = window.innerWidth || -1;
    if (width < maxWidth && width > 0 && willScroll === false) {
      document.body.classList.add(_configurator["default"].preventScroll); // eslint-disable-line
    } else {
      document.body.classList.remove(_configurator["default"].preventScroll); // eslint-disable-line
    }
  }
};
var getRootUrl = function getRootUrl() {
  if (typeof window !== 'undefined') {
    var rootUrl = '';
    var _window = window,
      location = _window.location;
    if (typeof location !== 'undefined') {
      rootUrl = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : '') + "/c/";
    }
    return rootUrl;
  }
};
var FUELTYPES = {
  'gasoline': ['Gasolina', 'Bi-Fuel', 'Unleaded'],
  'glp': ['Gasolina/GLP'],
  'hybrid': ['PHEV', 'HEV', 'MHEV Gasolina', 'MHEV', 'Plug-in Híbrido']
};
var getFuelValueByFuelType = function getFuelValueByFuelType(fuelType) {
  var _fueltype;
  var fueltype;
  if (fuelType) {
    Object.values(FUELTYPES).forEach(function (names, index) {
      var itemFound = names.filter(function (item) {
        return item.toLowerCase() === fuelType.toLowerCase();
      });
      if (itemFound && itemFound.length > 0) {
        fueltype = Object.keys(FUELTYPES)[index];
      }
      ;
    });
  }
  return (_fueltype = fueltype) == null ? void 0 : _fueltype.toLowerCase();
};
var ConfiguratorRedux = /*#__PURE__*/function (_React$Component) {
  function ConfiguratorRedux(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.confirmSelection = _this.confirmSelection.bind(_this);
    _this.openDataLossOverlay = _this.openDataLossOverlay.bind(_this);
    _this.closeDataLossOverlay = _this.closeDataLossOverlay.bind(_this);
    _this.closeChangeModelOverlay = _this.closeChangeModelOverlay.bind(_this);
    _this.toggleEvent = _this.handleToggleClick.bind(_this);
    _this.goToFirstStepOfPhase = _this.goToFirstStepOfPhase.bind(_this);
    _this.goToStepFromModal = _this.goToStepFromModal.bind(_this);
    _this.goToModelFromModal = _this.goToModelFromModal.bind(_this);
    _this.onEnterViewport = _this.onEnterViewport.bind(_this);
    _this.onExitViewport = _this.onExitViewport.bind(_this);
    _this.configuratorWrapper = /*#__PURE__*/_react["default"].createRef();
    _this.changeStepEvents = {
      changePreferences: undefined,
      changeModel: _this.changeModel.bind(_this),
      changeColor: _this.changeColor.bind(_this),
      changeFabric: _this.changeFabric.bind(_this),
      changePackages: _this.changePackages.bind(_this),
      changeAccessories: _this.changeAccessories.bind(_this),
      changeEquipment: _this.changeEquipment.bind(_this)
    };
    _this.phaseBreaks = props.hasAdditionalEquipmentStep ? [2] : [1];
    return _this;
  }
  (0, _inheritsLoose2["default"])(ConfiguratorRedux, _React$Component);
  ConfiguratorRedux.didSkipPrefsOnce = function didSkipPrefsOnce(prevPref, currPref) {
    return !!(prevPref === false && currPref === true);
  };
  ConfiguratorRedux.noPrefsInProps = function noPrefsInProps(driveType, transmissionType) {
    return ConfiguratorRedux.isEmpty(driveType) && ConfiguratorRedux.isEmpty(transmissionType) && ConfiguratorRedux.isEmpty(transmissionType);
  };
  ConfiguratorRedux.makeOptionsObjFromPreferences = function makeOptionsObjFromPreferences(preferences) {
    return {
      fuelType: preferences.fuelType,
      drivetrain: preferences.driveType,
      transmissionType: preferences.transmissionType
    };
  };
  ConfiguratorRedux.isEmpty = function isEmpty(value) {
    return !value || value === '' || typeof value === 'undefined' || value === null;
  };
  var _proto = ConfiguratorRedux.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var optionsToUpdate = {};
    var props = this.props;
    var _this$props = this.props,
      updateSelections = _this$props.updateSelections,
      preferences = _this$props.preferences,
      didSkipPrefs = _this$props.didSkipPrefs,
      skipOptions = _this$props.skipOptions,
      activeStep = _this$props.activeStep,
      fuelType = _this$props.fuelType,
      transmissionType = _this$props.transmissionType,
      driveType = _this$props.driveType,
      data = _this$props.data,
      model = _this$props.model,
      market = _this$props.market,
      currency = _this$props.config.currencyFormat;
    var needsUpdatedImages = false;
    carouselUpdateAttributes.forEach(function (attr) {
      if (prevProps[attr] !== props[attr]) {
        optionsToUpdate[attr] = props[attr];
        needsUpdatedImages = true;
      }
    });
    if (needsUpdatedImages) {
      updateSelections(_objectSpread(_objectSpread({}, preferences), optionsToUpdate));
    }
    if (ConfiguratorRedux.didSkipPrefsOnce(prevProps.didSkipPrefs, didSkipPrefs)) {
      this.addDefaultPrefsToRedux(skipOptions);
    }
    if (!didSkipPrefs && data.resourceType !== 'ModelPreferences_1_0_0' && activeStep !== 'ModelPreferencesSelector' && ConfiguratorRedux.noPrefsInProps(driveType, fuelType, transmissionType)) {
      this.addDefaultPrefsToRedux(ConfiguratorRedux.makeOptionsObjFromPreferences(preferences));
    }
    this.checkSummaryDocking();
    var isLastStep = data.progressBar.items.length === data.progressBar.items.findIndex(function (i) {
      return i.selected;
    }) + 1;
    if (isLastStep && (market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      var checkEventAlreadyPushed = window.dataLayer.filter(function (ev) {
        return ev.event === 'car_configuration_completed';
      });
      if (checkEventAlreadyPushed.length === 0) {
        var _data$vehicleInfo, _data$vehicleInfo2, _data$summary, _data$summary2, _data$summary3, _data$summary4, _data$summary5, _data$summary6, _data$summary7, _data$summary8;
        var filteredModel = data.models && data.models.length ? data.models.find(function (m) {
          return m.code === model;
        }) : {};
        window.dataLayer.push({
          event: 'car_configuration_completed',
          comp_product: {
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: data != null && (_data$vehicleInfo = data.vehicleInfo) != null && _data$vehicleInfo.name ? data == null || (_data$vehicleInfo2 = data.vehicleInfo) == null || (_data$vehicleInfo2 = _data$vehicleInfo2.name) == null ? void 0 : _data$vehicleInfo2.toLowerCase() : data != null && (_data$summary = data.summary) != null && (_data$summary = _data$summary.vehicle) != null && _data$summary.name ? data == null || (_data$summary2 = data.summary) == null || (_data$summary2 = _data$summary2.vehicle) == null || (_data$summary2 = _data$summary2.name) == null ? void 0 : _data$summary2.toLowerCase() : '',
            version: filteredModel != null && filteredModel.name ? filteredModel.name : data != null && (_data$summary3 = data.summary) != null && (_data$summary3 = _data$summary3.model) != null && _data$summary3.name ? data == null || (_data$summary4 = data.summary) == null || (_data$summary4 = _data$summary4.model) == null || (_data$summary4 = _data$summary4.name) == null ? void 0 : _data$summary4.toLowerCase() : '',
            color: data != null && (_data$summary5 = data.summary) != null && (_data$summary5 = _data$summary5.color) != null && _data$summary5.label ? data.summary.color.label.toLowerCase() : null,
            upholstery: data != null && (_data$summary6 = data.summary) != null && (_data$summary6 = _data$summary6.fabric) != null && _data$summary6.label ? data.summary.fabric.label.toLowerCase() : null,
            accesories: null,
            fuel_type: getFuelValueByFuelType(data != null && (_data$summary7 = data.summary) != null && (_data$summary7 = _data$summary7.fuelType) != null && _data$summary7.label ? data.summary.fuelType.label.toLowerCase() : filteredModel && filteredModel.fuelType && filteredModel.fuelType.toLowerCase() || null),
            price: data != null && (_data$summary8 = data.summary) != null && (_data$summary8 = _data$summary8.totalPrice) != null && _data$summary8.value ? data.summary.totalPrice.value : null,
            currency: currency.toLowerCase(),
            step: (data.progressBar.items.length + "/" + data.progressBar.items.length).toLowerCase(),
            status: 'ok'
          }
        });
      }
    }
  };
  _proto.handleToggleClick = function handleToggleClick() {
    var _this$props2 = this.props,
      dispatch = _this$props2.dispatch,
      summaryExpanded = _this$props2.summaryExpanded;
    setBodyScrollability(summaryExpanded);
    dispatch((0, _actions.setSummaryExpand)(!summaryExpanded));
  };
  _proto.onEnterViewport = function onEnterViewport(scrollInfo) {
    var _this$props3 = this.props,
      dispatch = _this$props3.dispatch,
      summaryDocked = _this$props3.summaryDocked;
    var progress = scrollInfo.progress;
    var shouldDock = progress > 0;
    if (summaryDocked !== shouldDock) {
      dispatch((0, _actions.setSummaryDocked)(shouldDock));
    }
  };
  _proto.onExitViewport = function onExitViewport(scrollInfo) {
    var _this$props4 = this.props,
      dispatch = _this$props4.dispatch,
      summaryDocked = _this$props4.summaryDocked;
    var progress = scrollInfo.progress;
    var shouldDock = progress > 0;
    if (summaryDocked !== shouldDock) {
      dispatch((0, _actions.setSummaryDocked)(shouldDock));
    }
  };
  _proto.addDefaultPrefsToRedux = function addDefaultPrefsToRedux(optionsObj) {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setFuelType)(optionsObj.fuelType));
    dispatch((0, _actions.setDriveType)(optionsObj.drivetrain));
    dispatch((0, _actions.setTransmissionType)(optionsObj.transmissionType));
  };
  _proto.checkSummaryDocking = function checkSummaryDocking() {
    var _this$props5 = this.props,
      dispatch = _this$props5.dispatch,
      summaryDocked = _this$props5.summaryDocked;
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // eslint-disable-line
      var windowHeight = window.innerHeight || document.documentElement.clientHeight; // eslint-disable-line
      var scrollTrackRect = this.configuratorWrapper.current.element.getBoundingClientRect();
      var shouldDock = scrollTrackRect.top > 0 && scrollTrackRect.top <= windowHeight;
      if (summaryDocked !== shouldDock) {
        dispatch((0, _actions.setSummaryDocked)(shouldDock));
      }
    }
  };
  _proto.confirmSelection = function confirmSelection(additionalValues) {
    var _this$props6 = this.props,
      color = _this$props6.color,
      fabric = _this$props6.fabric,
      fuelType = _this$props6.fuelType,
      driveType = _this$props6.driveType,
      transmissionType = _this$props6.transmissionType,
      model = _this$props6.model,
      packages = _this$props6.packages,
      accessories = _this$props6.accessories,
      dispatch = _this$props6.dispatch,
      setSelections = _this$props6.setSelections,
      preferences = _this$props6.preferences,
      trimLine = _this$props6.trimLine,
      data = _this$props6.data,
      market = _this$props6.market,
      stepMap = _this$props6.stepMap;
    var selections = {};
    var passedSelections = {};
    if (trimLine !== '') {
      selections.trimLine = trimLine;
    }
    if (color !== '') {
      selections.color = color;
    }
    if (fabric !== '') {
      selections.fabric = fabric;
    }
    if (fuelType !== '') {
      selections.fuelType = fuelType;
    }
    if (driveType !== '') {
      selections.driveType = driveType;
    }
    if (transmissionType !== '') {
      selections.transmissionType = transmissionType;
    }
    if (model !== '') {
      selections.model = model;
    }
    if (!isEmptyArray(packages)) {
      selections.packages = typeof packages === 'string' ? packages.split(',') : packages;
    }
    if (!isEmptyArray(accessories)) {
      selections.accessories = typeof accessories === 'string' ? accessories.split(',') : accessories;
    }
    if (additionalValues.target === undefined) {
      passedSelections = additionalValues;
    }
    setBodyScrollability(true);
    dispatch((0, _actions.setSummaryExpand)(false));
    setSelections(_objectSpread(_objectSpread(_objectSpread({}, preferences), selections), passedSelections));
    var currency = this.props.config.currencyFormat;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      var _data$vehicleInfo3, _data$vehicleInfo4, _data$summary9, _data$summary0, _data$summary1, _data$summary10, _data$summary11, _data$summary12, _data$summary13, _data$summary14;
      var filteredModel = data.models && data.models.length ? data.models.find(function (m) {
        return m.code === selections.model;
      }) : {};
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'car_configuration_steps',
        comp_product: {
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: data != null && (_data$vehicleInfo3 = data.vehicleInfo) != null && _data$vehicleInfo3.name ? data == null || (_data$vehicleInfo4 = data.vehicleInfo) == null || (_data$vehicleInfo4 = _data$vehicleInfo4.name) == null ? void 0 : _data$vehicleInfo4.toLowerCase() : data != null && (_data$summary9 = data.summary) != null && (_data$summary9 = _data$summary9.vehicle) != null && _data$summary9.name ? data == null || (_data$summary0 = data.summary) == null || (_data$summary0 = _data$summary0.vehicle) == null || (_data$summary0 = _data$summary0.name) == null ? void 0 : _data$summary0.toLowerCase() : '',
          version: filteredModel != null && filteredModel.name ? filteredModel.name : data != null && (_data$summary1 = data.summary) != null && (_data$summary1 = _data$summary1.model) != null && _data$summary1.name ? data == null || (_data$summary10 = data.summary) == null || (_data$summary10 = _data$summary10.model) == null || (_data$summary10 = _data$summary10.name) == null ? void 0 : _data$summary10.toLowerCase() : '',
          color: data != null && (_data$summary11 = data.summary) != null && (_data$summary11 = _data$summary11.color) != null && _data$summary11.label ? data.summary.color.label.toLowerCase() : null,
          upholstery: data != null && (_data$summary12 = data.summary) != null && (_data$summary12 = _data$summary12.fabric) != null && _data$summary12.label ? data.summary.fabric.label.toLowerCase() : null,
          accesories: null,
          fuel_type: getFuelValueByFuelType(data != null && (_data$summary13 = data.summary) != null && (_data$summary13 = _data$summary13.fuelType) != null && _data$summary13.label ? data.summary.fuelType.label.toLowerCase() : filteredModel && filteredModel.fuelType && filteredModel.fuelType.toLowerCase() || null),
          price: data != null && (_data$summary14 = data.summary) != null && (_data$summary14 = _data$summary14.totalPrice) != null && _data$summary14.value ? data.summary.totalPrice.value : null,
          currency: currency.toLowerCase(),
          step: data.progressBar.items.findIndex(function (s) {
            return s.selected;
          }) + 1 + "/" + data.progressBar.items.length
        }
      });
    }
    if (market.toLowerCase() === 'ca' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      var stepInformation = stepMap.find(function (step) {
        return step.id === data.resourceType;
      });
      if (stepInformation && stepInformation.label) {
        if (stepInformation.label.toLowerCase() === 'modelselector') {
          var _data$vehicleInfo5, _data$vehicleInfo6, _data$summary15, _data$summary16, _data$vehicleInfo7;
          var vehicleName = data != null && (_data$vehicleInfo5 = data.vehicleInfo) != null && _data$vehicleInfo5.name ? data == null || (_data$vehicleInfo6 = data.vehicleInfo) == null || (_data$vehicleInfo6 = _data$vehicleInfo6.name) == null ? void 0 : _data$vehicleInfo6.toLowerCase() : data != null && (_data$summary15 = data.summary) != null && (_data$summary15 = _data$summary15.vehicle) != null && _data$summary15.name ? data == null || (_data$summary16 = data.summary) == null || (_data$summary16 = _data$summary16.vehicle) == null || (_data$summary16 = _data$summary16.name) == null ? void 0 : _data$summary16.toLowerCase() : '';
          var nameplate = vehicleName ? (0, _commonLibs.getNameplateByVehicleName)(vehicleName) : '';
          var _getCachedLocation = (0, _commonSetLocation.getCachedLocation)(),
            stateCode = _getCachedLocation.stateCode,
            postalCode = _getCachedLocation.postalCode,
            city = _getCachedLocation.city;
          var dataCollection = {
            event: "bnp_select_trim",
            nameplate: nameplate,
            vehicle_year: (data == null || (_data$vehicleInfo7 = data.vehicleInfo) == null ? void 0 : _data$vehicleInfo7.year) || '',
            vehicle_trim: (0, _commonLibs.getTrimNameByModelCode)(selections.model, data.models) || '',
            accessories: "",
            //accessories are not selected at this step
            vehicle_category_code: _commonLibs.VEHICLE_CATEGORY_CODES[nameplate],
            province: stateCode == null ? void 0 : stateCode.toLowerCase(),
            postal_code: postalCode == null ? void 0 : postalCode.toUpperCase(),
            city: city == null ? void 0 : city.toLowerCase()
          };
          dataCollection = (0, _commonLibs.cleanObject)(dataCollection);
          window.dataLayer.push(dataCollection);
        }
      }
    }
    if (market.toLowerCase() === 'ro' && typeof window !== 'undefined' && window.dataLayer) {
      var _filteredModel = data.models && data.models.length ? data.models.find(function (m) {
        return m.code === selections.model;
      }) : {};
      window.dataLayer = window.dataLayer || [];
      var _stepInformation = stepMap.find(function (step) {
        return step.id === data.resourceType;
      });
      if (_stepInformation && _stepInformation.label) {
        if (_stepInformation.label.toLowerCase() === 'modelselector') {
          window.dataLayer.push({
            event: 'configurator_model',
            model_selected: _filteredModel && _filteredModel.name || null
          });
        }
        if (_stepInformation.label.toLowerCase() === 'colorselector') {
          var _data$summary17;
          window.dataLayer.push({
            event: 'configurator_color',
            color_selected: (data == null || (_data$summary17 = data.summary) == null || (_data$summary17 = _data$summary17.color) == null ? void 0 : _data$summary17.label) || null
          });
        }
        if (_stepInformation.label.toLowerCase() === 'fabricselector') {
          var _data$summary18;
          window.dataLayer.push({
            event: 'configurator_material',
            material_selected: (data == null || (_data$summary18 = data.summary) == null || (_data$summary18 = _data$summary18.fabric) == null ? void 0 : _data$summary18.label) || null
          });
        }
        if (_stepInformation.label.toLowerCase() === 'accessoriesselector') {
          var _data$summary19, _data$summary20;
          window.dataLayer.push({
            event: 'configurator_accessory',
            accessory_selected: (data == null || (_data$summary19 = data.summary) == null ? void 0 : _data$summary19.accessories.length) && (data == null || (_data$summary20 = data.summary) == null ? void 0 : _data$summary20.accessories.reduce(function (acc, curr) {
              return acc ? acc.concat(", " + curr.label) : acc.concat(curr.label);
            }, '')) || null
          });
        }
      }
    }
  };
  _proto.goToFirstStepOfPhase = function goToFirstStepOfPhase() {
    var phaseBreaks = this.phaseBreaks;
    var _this$props7 = this.props,
      data = _this$props7.data,
      hasAdditionalEquipmentStep = _this$props7.hasAdditionalEquipmentStep;
    var firstStepOfPhase = getFirstStepOfActivePhaseFromProgressBar(data.progressBar, phaseBreaks);
    if (firstStepOfPhase === 1) {
      this.openChangeModelOverlay(firstStepOfPhase);
    } else if (firstStepOfPhase === 2 && hasAdditionalEquipmentStep) {
      this.triggerStepNavigationToIndex(1);
    } else {
      this.openDataLossOverlay(firstStepOfPhase);
    }
  };
  _proto.changeModel = function changeModel() {
    var hasAdditionalEquipmentStep = this.props.hasAdditionalEquipmentStep;
    if (hasAdditionalEquipmentStep) {
      var stepIndex = 1;
      this.triggerStepNavigationToIndex(stepIndex);
    } else {
      this.openChangeModelOverlay();
    }
  };
  _proto.changeEquipment = function changeEquipment() {
    var stepIndex = 2;
    this.triggerStepNavigationToIndex(stepIndex);
  };
  _proto.changeColor = function changeColor() {
    var hasAdditionalEquipmentStep = this.props.hasAdditionalEquipmentStep;
    var stepIndex = hasAdditionalEquipmentStep ? 3 : 2;
    this.triggerStepNavigationToIndex(stepIndex);
  };
  _proto.changeFabric = function changeFabric() {
    var hasAdditionalEquipmentStep = this.props.hasAdditionalEquipmentStep;
    var stepIndex = hasAdditionalEquipmentStep ? 4 : 3;
    this.triggerStepNavigationToIndex(stepIndex);
  };
  _proto.changePackages = function changePackages() {
    var hasAdditionalEquipmentStep = this.props.hasAdditionalEquipmentStep;
    var stepIndex = hasAdditionalEquipmentStep ? 5 : 4;
    this.triggerStepNavigationToIndex(stepIndex);
  };
  _proto.changeAccessories = function changeAccessories() {
    var hasAdditionalEquipmentStep = this.props.hasAdditionalEquipmentStep;
    var stepIndex = hasAdditionalEquipmentStep ? 6 : 5;
    this.triggerStepNavigationToIndex(stepIndex);
  };
  _proto.goToModelFromModal = function goToModelFromModal() {
    this.closeChangeModelOverlay();
    this.resetOptions();
    this.triggerStepNavigationToIndex(0, true);
  };
  _proto.goToStepFromModal = function goToStepFromModal() {
    var _this$props8 = this.props,
      dataLossModalDesiredStep = _this$props8.dataLossModalDesiredStep,
      router = _this$props8.router,
      data = _this$props8.data,
      hasSelector = _this$props8.hasSelector;
    var progressBar = data.progressBar || {};
    this.closeDataLossOverlay();
    if (dataLossModalDesiredStep === 0 && !hasSelector) {
      var selectionUrl = handleNestedProp(progressBar, 'progressBar.previousCta.URL');
      if (selectionUrl !== ' ' && typeof router !== 'undefined') {
        router.push(selectionUrl);
      }
    } else {
      this.triggerStepNavigationToIndex(dataLossModalDesiredStep, true);
    }
  };
  _proto.triggerStepNavigationToIndex = function triggerStepNavigationToIndex(desiredIndex, clearPreferences) {
    var _this$props9 = this.props,
      dispatch = _this$props9.dispatch,
      goToStepFromIndex = _this$props9.goToStepFromIndex;
    setBodyScrollability(true);
    dispatch((0, _actions.setSummaryExpand)(false));
    goToStepFromIndex(desiredIndex, clearPreferences);
  };
  _proto.openDataLossOverlay = function openDataLossOverlay(desiredStep) {
    if (desiredStep === void 0) {
      desiredStep = 0;
    }
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setDataLossModal)(true, desiredStep));
  };
  _proto.openChangeModelOverlay = function openChangeModelOverlay() {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setChangeModelModal)(true));
  };
  _proto.closeDataLossOverlay = function closeDataLossOverlay() {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setDataLossModal)(false, null));
  };
  _proto.closeChangeModelOverlay = function closeChangeModelOverlay() {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.setChangeModelModal)(false, null));
  };
  _proto.resetOptions = function resetOptions() {
    var dispatch = this.props.dispatch;
    dispatch((0, _actions.resetPreferences)());
  };
  _proto.render = function render() {
    var phaseBreaks = this.phaseBreaks;
    var _this$props0 = this.props,
      changeVehicleOverlay = _this$props0.changeVehicleOverlay,
      summaryExpanded = _this$props0.summaryExpanded,
      summaryDocked = _this$props0.summaryDocked,
      dataLossModal = _this$props0.dataLossModal,
      changeModelModal = _this$props0.changeModelModal,
      preferences = _this$props0.preferences,
      minorQueryPending = _this$props0.minorQueryPending,
      updateSelections = _this$props0.updateSelections,
      activeStep = _this$props0.activeStep,
      config = _this$props0.config,
      market = _this$props0.market,
      data = _this$props0.data,
      _this$props0$theme = _this$props0.theme,
      theme = _this$props0$theme === void 0 ? {} : _this$props0$theme,
      addPriceDisclaimer = _this$props0.addPriceDisclaimer,
      priceDisclaimerId = _this$props0.priceDisclaimerId,
      disclaimerData = _this$props0.disclaimerData,
      hasModelsOrdering = _this$props0.hasModelsOrdering,
      stepMap = _this$props0.stepMap,
      hasAdditionalEquipmentStep = _this$props0.hasAdditionalEquipmentStep;
    var _this$changeStepEvent = this.changeStepEvents,
      changeModel = _this$changeStepEvent.changeModel,
      changeColor = _this$changeStepEvent.changeColor,
      changeFabric = _this$changeStepEvent.changeFabric,
      changePackages = _this$changeStepEvent.changePackages,
      changeAccessories = _this$changeStepEvent.changeAccessories;
    var stepData = data || {};
    var summaryData = stepData.summary || {};
    var changeModelOverlay = JSON.parse(JSON.stringify(changeVehicleOverlay));
    var rootUrl = getRootUrl();
    var progressBarData = {};
    if (stepData.progressBar) {
      changeModelOverlay.overlayCopy.title = stepData.progressBar.previousCta.label;
      progressBarData = getShapedSecondaryNavData({
        phaseBreaks: phaseBreaks,
        progressBar: stepData.progressBar,
        backEvent: this.goToFirstStepOfPhase,
        changeStepEvents: this.changeStepEvents,
        eventKeys: Object.keys(this.changeStepEvents),
        stepMap: stepMap
      });
    }
    var nextStepLabel = getNextStepLabel(stepData.progressBar);
    var StepInformation = stepMap.find(function (step) {
      return step.id === stepData.resourceType;
    });
    var StepContainer = StepInformation ? StepInformation.component : _preferencesSelector["default"];
    var backgroundImage = handleNestedProp(stepData, 'stepData.backgroundImage.image');
    var isMissingBackgroundImage = !!(backgroundImage === ' ' || backgroundImage === '');
    var isSummaryStep = stepData.resourceType === 'SummarySelector_1_0_0';
    var imageWidth = 1600;
    var _config$languageDirec = config.languageDirectionMap.find(function (el) {
        return el.language === config.language;
      }),
      _config$languageDirec2 = _config$languageDirec.direction,
      languageDirection = _config$languageDirec2 === void 0 ? 'ltr' : _config$languageDirec2;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMissingBackgroundImage && !isSummaryStep && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _configurator["default"].stepBackgroundWrapper
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: "" + _configurator["default"].stepBackgroundImage,
      src: appendImageTransforms(backgroundImage, imageWidth),
      width: imageWidth,
      alt: handleNestedProp(stepData, 'stepData.backgroundImage.altText') || ''
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].stepWrapper + " " + theme.lock_LTR + " " + (isSummaryStep && isMissingBackgroundImage ? _configurator["default"].summaryState : '')
    }, !isEmptyObject(progressBarData) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].progressBarWrapper
    }, /*#__PURE__*/_react["default"].createElement(_configuratorSecondaryNavigation.ConfiguratorSecondaryNavigation, {
      data: progressBarData,
      theme: theme,
      direction: languageDirection
    })), /*#__PURE__*/_react["default"].createElement(StepContainer, {
      direction: languageDirection,
      market: market,
      minorQueryPending: minorQueryPending,
      theme: theme,
      data: stepData,
      updateSelections: updateSelections,
      confirmSelection: this.confirmSelection,
      changeStepEvents: this.changeStepEvents,
      preferences: preferences,
      rootUrl: rootUrl,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      hasModelsOrdering: hasModelsOrdering,
      hasAdditionalEquipmentStep: hasAdditionalEquipmentStep
    }), !isEmptyObject(summaryData) && !isSummaryStep && /*#__PURE__*/_react["default"].createElement(_configuratorSmallSummary.ConfiguratorSmallSummary, {
      stepId: activeStep,
      summaryExpanded: summaryExpanded,
      isDocked: summaryDocked,
      theme: theme,
      nextStepLabel: nextStepLabel,
      data: summaryData,
      rootUrl: rootUrl,
      nextButtonEvent: this.confirmSelection,
      changeModel: changeModel,
      changeColor: changeColor,
      changeFabric: changeFabric,
      changePackages: changePackages,
      changeAccessories: changeAccessories,
      direction: languageDirection,
      market: market,
      config: config,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    }), !isEmptyObject(changeVehicleOverlay) && /*#__PURE__*/_react["default"].createElement(_commonDialog.CommonDialog, {
      direction: languageDirection,
      isOpen: dataLossModal,
      data: changeVehicleOverlay,
      closeEvent: this.closeDataLossOverlay,
      linkEvents: [this.goToStepFromModal, this.closeDataLossOverlay],
      theme: theme
    }), !isEmptyObject(changeModelOverlay) && /*#__PURE__*/_react["default"].createElement(_commonDialog.CommonDialog, {
      direction: languageDirection,
      isOpen: changeModelModal,
      data: changeModelOverlay,
      closeEvent: this.closeChangeModelOverlay,
      linkEvents: [this.goToModelFromModal, this.closeChangeModelOverlay],
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement(_reactScrollTrigger["default"], {
      ref: this.configuratorWrapper,
      throttleScroll: 30,
      onEnter: this.onEnterViewport,
      onExit: this.onExitViewport
    }));
  };
  return ConfiguratorRedux;
}(_react["default"].Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    config: state.Config,
    value: state.number.value,
    color: state.color.value,
    fabric: state.fabric.value,
    fuelType: state.fuelType.value,
    driveType: state.driveType.value,
    transmissionType: state.transmissionType.value,
    model: state.model.value,
    trimLine: state.trimLine.value,
    packages: state.packages.value,
    accessories: state.accessories.value,
    summaryExpanded: state.summaryExpanded.value,
    summaryDocked: state.summaryDocked.value,
    dataLossModal: state.dataLossModal.value,
    dataLossModalDesiredStep: state.dataLossModal.desiredStep,
    changeModelModal: state.changeModelModal.value,
    preferences: props.preferences,
    minorQueryPending: props.minorQueryPending,
    theme: props.theme,
    activeStep: props.activeStep,
    data: props.data
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(ConfiguratorRedux);